/* @flow */
import axios from 'axios'
import oPath from 'object-path'

import {computePaginateSortFilterParams, computedCollectionCount} from '@/utils/api'
import {NEW_NOTIFICATION} from './notifications'

export const FETCH_GATEWAY_STATISTICS = 'FETCH_GATEWAY_STATISTICS'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    [FETCH_GATEWAY_STATISTICS]: async function({dispatch}: Object, payload: Object) {
      try {
        const {data} = await axios.get(
          `/gateways/${payload.context.eui}/gateway_statistics`,
          {
            params: computePaginateSortFilterParams(payload),
          }
        )

        const {pagination} = data.meta
        return {
          success: true,
          // Return fetched data as flat array
          items: data.data.map(item => item.attributes),
          collectionCount: computedCollectionCount({
            endRow: payload.endRow,
            filteredCount: pagination.filtered_count,
            collectionCount: pagination.collection_count,
          }),
        }
      } catch (err) {
        if (oPath.get(err, 'response.status') !== 404) {
          dispatch(NEW_NOTIFICATION, {
            text: 'Failed to load gateway statistics ',
            detail: err.message,
            color: 'error',
          })
        }
      }
      return {success: false}
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/gateway_statistics.js